var Curriculog = Curriculog || {};
Curriculog.ProposalToolbox = Curriculog.ProposalToolbox || {};

Curriculog.ProposalToolbox.TrackingDropdown = (function ($, _, Backbone, TrackingDropdown) {

    TrackingDropdown = Curriculog.CurriculogView.extend({
        el: function() {
            return $('#tracking');
        },

        initialize: function (options) {
            var that = this;
            this.$viewMode = $('#view-mode');
            this.$editFilter = $('#edits-filter-select');

            // Modes: current, currentMarkup, original
            this.mode = this.mode || 'current';

            // Alright, `edits` is a nasty carry-over from the old way doing things.
            // Edits will either be a list of users to show edits for, or false to show all edits.
            this.edits = false;

            this.initSelects();
            this.render();
        },

        initSelects: function() {
            var that = this;

            this.$viewMode.val(this.mode);

            try{
                this.$viewMode.multiselect('destroy');
                this.$editFilter.multiselect('destroy');
            } catch(e){}

            this.$viewMode.multiselect({
                minWidth: 550,
                header: false,
                classes: 'edits-filter-multiselect single-filter-select',
                height: 75,
                multiple: false,
                noneSelectedText: 'Show current',
                selectedText: function (numChecked, numTotal, checkedItems) {
                    return $(checkedItems).attr('title');
                },
                click: function (event, ui) {
                    that.mode = ui.value;
                    that.edits = [];
                    if (ui.value === 'currentMarkup') {
                        that.edits = false;
                        that.$editFilter.multiselect('enable');
                    } else {
                        that.$editFilter.multiselect('disable');
                        that.$editFilter.find('option').prop('selected', 1);
                        that.$editFilter.multiselect('refresh');
                        $('#files-content-markup').remove();
                    }
                    Backbone.trigger('form:reload');
                    that.$editFilter.multiselect('refresh');
                }
            });

            this.$editFilter.multiselect({
                minWidth: 550,
                classes: 'edits-filter-multiselect user-edits',
                noneSelectedText: 'Show Individual User Edits',
                selectedText: function (numChecked, numTotal, checkedItems) {
                    if (numChecked === numTotal) {
                        return 'Showing All Edits by All Users';
                    } else {
                        return 'Showing ' + numChecked + ' User Edits';
                    }
                },
                open: function (event, ui) {
                    $('.user-edits .ui-multiselect-checkboxes li:not(.ui-multiselect-optgroup-label)').each(function(index, item) {
                        if ($(item).find('.user-color').length === 0) {
                            var classes = $(item).attr('class');
                            var username = $(this).find('span').text();
                            $(item).find('span').contents().replaceWith('<span class="' + classes+ '"></span>' + username);
                            $(item).removeAttr('class');
                        }
                    });
                },
                click: _.bind(that.filterChange, that),
                optgrouptoggle: _.bind(that.filterChange, that),
                checkAll: _.bind(that.filterChange, that, true),
                uncheckAll: _.bind(that.filterChange, that)
            });

            if (this.mode != 'currentMarkup'){
                this.$editFilter.multiselect('disable');
            }
        },

        render: function () {
            this.setElement($('#tracking'));
            this.$viewMode = $('#view-mode');
            this.$editFilter = $('#edits-filter-select');

            this.$editFilter.multiselect('refresh');
        },

        reset: function () {
            this.mode = 'current';
            this.edits = false;
            this.$viewMode.val(this.mode);
            this.$viewMode.multiselect('refresh');
            this.$editFilter.multiselect('disable');
            this.$editFilter.find('option').prop('selected', 1);
            this.$editFilter.multiselect('refresh');

            $('#files-content-markup').remove();
        },

        getMode: function () {
            return this.mode;
        },

        getEdits: function () {
            return this.edits;
        },

        filterChange: function (checkAll) {
            var edits = this.$editFilter.multiselect('getChecked');
            this.edits = _.flatten(_.map(edits, function(item) {
                return _.tail(item.value.split('-'));
            }));
            if (this.edits.length === 0) {
              this.mode = 'original';
            } else if (checkAll === true) {
              this.edits = false;
              this.mode = 'currentMarkup';
              this.$editFilter.multiselect('close');
            }
            Backbone.trigger('form:reload');
        }

    });

    return TrackingDropdown;

})($, _, Backbone, Curriculog.ProposalToolbox.TrackingDropdown || {});
